import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    SimpleChanges,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';
import { ProductService } from '../../../product/shared/product.service';

@Component({
    selector: 'vision2-subnav',
    imports: [CommonModule, PipesModule, TranslateModule],
    templateUrl: './subnav.component.html',
    styleUrl: './subnav.component.scss',
})
export class SubnavComponent implements OnChanges {
    @Input() productData: any;
    @Output() onRequestOpen: EventEmitter<string> = new EventEmitter<string>();
    consoleSlug: string | null = null;
    webDisplayName: string;

    constructor(private productService: ProductService) {}

    ngOnChanges(changes: SimpleChanges) {
        this.webDisplayName = this.productService.getWebDisplayName(
            changes.productData.currentValue,
        );
    }

    openModal(id: string) {
        this.onRequestOpen.emit(id);
    }
}
